export default __webpack_public_path__ + "static/media/liljohnjohn.c49a67e8.png";